import { Button, Stack } from '@mantine/core';
import { randomId } from '@mantine/hooks';
import { modals } from '@mantine/modals';
import * as React from 'react';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useNestedDialogFunction } from '../../../../../../../react-commons/dialog-provider/UseNestedDialogFunction';
import { OpenModal } from '../../../../../../../react-commons/utils/modals/openModal';
import { useActivitiesActions } from '../../../../../resource/resources/artifacts/activities/activitiesResource';
import { ActivityCreationDialog } from '../../../../page-components/project/reusable-elements/activity/ActivityCreationDialog';
import { Controlled_AutocompleteReferenceTextField } from '../../../../reusable-components/base/reference-text-fields/Controlled_AutocompleteReferenceTextField';

export function ActivityReferenceCreatorFunction(
    versionId: string,
    onConfirm: (objectId: string) => void,
    existingObjectId?: string
) {
    const id = randomId();
    OpenModal.ContentModal({
        title: 'Select Reference',
        content: (
            <ActivityReferenceCreatorDialog
                initialObjectId={existingObjectId}
                _versionId={versionId}
                onConfirm={(objectId) => {
                    onConfirm(objectId);
                    modals.close(id);
                }}
            />
        ),
        id: id,
        zIndex: 200,
    });
}

const ActivityReferenceCreatorDialog = ({
    initialObjectId,
    _versionId,
    onConfirm,
}: {
    initialObjectId?: string;
    _versionId: string;
    onConfirm: (objectId: string) => void;
}) => {
    const [selectedObjectId, setSelectedObjectId] = useState<string | null>(initialObjectId ?? null);
    const { versionId } = useParams<{ versionId: string | undefined }>();

    const nestedDialog = useNestedDialogFunction();
    const activityActions = useActivitiesActions();
    const allActivitysQuery = activityActions.useGetAllResources(versionId ?? _versionId);

    const onAdd = () => {
        nestedDialog.showNestedDialog(
            <ActivityCreationDialog parentId={versionId ?? _versionId} onClose={nestedDialog.closeNestedDialog} />
        );
    };

    return (
        <Stack align="stretch" justify="center">
            <Controlled_AutocompleteReferenceTextField
                idValue={selectedObjectId}
                readOnly={false}
                onChange={(value) => setSelectedObjectId(value)}
                label={'Activity'}
                propertyDetails={undefined}
                propertyValidation={undefined}
                query={allActivitysQuery}
                getOptionLabel={(option) => option.name}
                onAdd={onAdd}
            />
            <Button onClick={() => onConfirm(selectedObjectId ?? '')} disabled={!selectedObjectId}>
                Select
            </Button>
        </Stack>
    );
};
